import * as T from '@/types'

export enum CurrencyCode {
    GBP = 'gbp',
    USD = 'usd',
    EUR = 'eur',
}

export interface CurrencyDefinition {
    currencyCode: T.CurrencyCode
    displayName: string
    icon: string
    symbol: string
}
